<script setup>
import CompanyRatingStars from 'JIX/components/CompanyRatingStars.vue';
import ParagraphText from 'JIX/components/ParagraphText.vue';
import T from './CompanyRatingComment.i18n.js';
import SvgIcon from 'JIX/components/SvgIcon.vue';

import 'icons/feedback-positive-selected.svg';
import 'icons/feedback-negative-selected.svg';

defineProps({
    commentData: {
        type: Object,
        required: true,
    },
    companyname: {
        type: String,
        required: true,
        default: "",
    },
    isAdm: {
        type: Boolean,
        required: false,
        default: false,
    }
});
</script>

<template>
    <div class="mb-4 p-4 bg-surface-default border">
        <div
            class="mb-4 row"
            v-if="commentData.comment_positive.length > 0"
        >
            <div class="col-md-1 d-none d-md-block text-brand">
                <SvgIcon
                    name="feedback-positive-selected"
                    size="sm"
                    :aria-label="T.positiveComment()"
                />
            </div>
            <div class="col-md-11">
                <h4 class="d-md-none h6 mb-1">
                    {{ T.positiveComment() }}
                </h4>
                <ParagraphText :text="commentData.comment_positive" />
            </div>
        </div>

        <div
            class="mb-4 row"
            v-if="commentData.comment_negative.length > 0"
        >
            <div class="col-md-1 d-none d-md-block text-brand">
                <SvgIcon
                    name="feedback-negative-selected"
                    size="sm"
                    :aria-label="T.negativeComment()"
                />
            </div>
            <div class="col-md-11">
                <h4 class="d-md-none h6 mb-1">
                    {{ T.negativeComment() }}
                </h4>
                <ParagraphText :text="commentData.comment_negative" />
            </div>
        </div>
        <div class="row">
            <div class="col-1" />
            <div class="col-md-11 d-flex text-sm mt-2 flex-column flex-md-row">
                <CompanyRatingStars
                    :rating="commentData.rating"
                    size="inline"
                    style="align-items: center"
                />
                <div class="mt-2 mt-md-0 ml-md-3 d-block d-md-inline">
                    {{ T.writerDate(T.statusName(commentData.still_employed), commentData.date) }}
                </div>
                <div class="ml-auto mt-4 mt-md-0">
                    <a
                        v-if="isAdm && commentData.comments.length === 0"
                        :href="commentData.reply_url"
                        class="text-sm text-decoration-none mr-3"
                        rel="nofollow"
                    >
                        {{ T.replyComment() }}
                    </a>
                    <a
                        :href="commentData.report_url"
                        class="text-sm text-decoration-none"
                        rel="nofollow"
                    >
                        {{ T.reportComment() }}
                    </a>
                </div>
            </div>
        </div>
        <div
            v-for="(response, index) in commentData.comments"
            :key="index"
            class="bg-surface-1 border-top border-primary p-4 mt-2"
        >
            <h4>
                {{ T.responseCommentHeader(companyname) }}
            </h4>
            <ParagraphText :text="response.comment" />
            <div class="text-right">
                <a
                    v-if="isAdm"
                    :href="commentData.reply_url"
                    class="text-sm text-decoration-none mr-3"
                    rel="nofollow"
                >
                    {{ T.editComment() }}
                </a>
                <a
                    :href="response.report_url"
                    class="text-sm mt-2 text-decoration-none"
                    rel="nofollow"
                >
                    {{ T.reportResponseComment() }}
                </a>
            </div>
        </div>
    </div>
</template>
